import * as types from './actionTypes';

export default searchTerm => ({ type: types.SET_SEARCH_TERM, searchTerm });
